// extracted by mini-css-extract-plugin
export default {"searchBox":"Search_searchBox__-++ou","inputSearch":"Search_inputSearch__34cXT"};